module.exports = __webpack_public_path__ + "static/media/employee_experience_2.67cc936c.png";